module.exports = __webpack_public_path__ + "static/media/1013138.a260792c.png";